import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { motion } from 'framer-motion'
import SafeIcon from '../../common/SafeIcon'
import * as FiIcons from 'react-icons/fi'

const { FiTrendingUp, FiBook, FiBarChart2, FiCpu, FiSettings } = FiIcons

const BottomNav = () => {
  const location = useLocation()
  
  const navItems = [
    { path: '/dashboard', label: 'Home', icon: FiTrendingUp },
    { path: '/journal', label: 'Journal', icon: FiBook },
    { path: '/analytics', label: 'Stats', icon: FiBarChart2 },
    { path: '/insights', label: 'AI', icon: FiCpu },
    { path: '/settings', label: 'Settings', icon: FiSettings }
  ]

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 lg:hidden">
      <motion.div 
        className="bg-white/90 dark:bg-[#0f172a]/95 backdrop-blur-2xl border-t border-gray-200 dark:border-white/5 px-2 pb-safe pt-1 flex justify-around items-center h-20"
        initial={{ y: 100 }}
        animate={{ y: 0 }}
        transition={{ type: 'spring', damping: 25, stiffness: 200 }}
      >
        {navItems.map((item) => {
          const isActive = location.pathname === item.path
          return (
            <Link 
              key={item.path} 
              to={item.path}
              className="relative flex flex-col items-center justify-center py-2 w-full group"
            >
              <div className="relative">
                <motion.div
                  animate={{ 
                    scale: isActive ? 1.1 : 1,
                    color: isActive ? '#3b82f6' : '#94a3b8'
                  }}
                  className="relative z-10 flex flex-col items-center"
                >
                  <SafeIcon 
                    icon={item.icon} 
                    className={`h-6 w-6 mb-1 ${isActive ? 'text-lux-primary drop-shadow-[0_0_8px_rgba(59,130,246,0.3)]' : 'text-gray-400 dark:text-slate-500'}`} 
                  />
                  <span className={`text-[10px] font-bold uppercase tracking-tighter ${isActive ? 'text-lux-primary' : 'text-gray-400 dark:text-slate-500'}`}>
                    {item.label}
                  </span>
                </motion.div>
                
                {isActive && (
                  <motion.div 
                    layoutId="bottom-nav-indicator"
                    className="absolute -top-3 left-1/2 -translate-x-1/2 w-10 h-1 bg-lux-primary rounded-full shadow-[0_0_12px_rgba(59,130,246,0.8)]"
                    transition={{ type: 'spring', bounce: 0.2, duration: 0.6 }}
                  />
                )}
              </div>
            </Link>
          )
        })}
      </motion.div>
    </div>
  )
}

export default BottomNav